<template>
    <div class="control-menu">
        <div class="flex flex-col control-buttons">
            <template v-if="localUnlocked">
                <transition name="slide-fade-right" appear>
                    <vx-action-icon
                        is-button
                        color="success"
                        icon="SaveIcon"
                        tooltip="Save Changes"
                        tooltip-position="left"
                        :disabled="disabled"
                        @click.native.prevent.stop="commit"
                    />
                </transition>
                <transition name="slide-fade-right" appear>
                    <vx-action-icon
                        is-button
                        :class="{ disabled: !isModified }"
                        :disabled="!isModified || disabled"
                        color="warning"
                        icon="RotateCcwIcon"
                        tooltip="Undo All Changes"
                        tooltip-position="left"
                        @click.native.prevent.stop="rollback"
                    />
                </transition>
                <component
                    :is="isEmpty ? 'vx-dropdown' : 'div'"
                    :visible="showHints"
                    align="left"
                    justify="start"
                    :color="guidanceColor"
                    key="add"
                    class="mb-12"
                >
                    <transition name="slide-fade-right" appear>
                        <vx-action-icon
                            is-button
                            :class="{ disabled: noWidgets }"
                            :disabled="noWidgets || disabled"
                            color="primary"
                            icon="PlusCircleIcon"
                            tooltip="Add Widgets"
                            tooltip-position="left"
                            @click.native.prevent.stop="widgetDrawOpen = true"
                        />
                    </transition>
                    <template slot="menu">
                        <div class="p-4">
                            <h3 style="width: 300px">Add A Widget</h3>
                            <p>Try adding some by clicking here...</p>
                        </div>
                    </template>
                </component>
                <transition name="slide-fade-right" appear>
                    <vx-action-icon
                        is-button
                        :class="{ disabled: isEmpty }"
                        :disabled="isEmpty || disabled"
                        class="mt-12"
                        color="danger"
                        icon="TrashIcon"
                        tooltip="Remove All"
                        tooltip-position="left"
                        @click.native.prevent.stop="clear"
                    />
                </transition>
            </template>
            <template v-else>
                <component
                    :is="isEmpty ? 'vx-dropdown' : 'div'"
                    :visible="showHints"
                    align="left"
                    justify="start"
                    :color="guidanceColor"
                    key="start"
                >
                    <transition name="slide-fade-right" appear>
                        <vx-action-icon
                            is-button
                            color="warning"
                            :disabled="disabled"
                            icon="Edit2Icon"
                            @click.native.prevent.stop="unlock"
                        />
                    </transition>
                    <template slot="menu">
                        <div class="p-4" style="width: fit-content">
                            <h3 style="width: 300px">New Custom Dashboards</h3>
                            <p>
                                Looks like you don't have any widgets yet. Try adding some by
                                clicking here...
                            </p>
                        </div>
                    </template>
                </component>
            </template>
        </div>
        <widget-tray
            v-bind="$attrs"
            v-on="$listeners"
            :open.sync="widgetDrawOpen"
            :widgets="widgets"
        />
    </div>
</template>

<script>
import VxWindowPane from '../VxWindowPane.vue'
import WidgetTray from './WidgetTray.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'control-menu',
    components: { VxWindowPane, WidgetTray },
    props: {
        unlocked: {
            type: Boolean
        },
        widgets: {
            type: Array,
            default: () => []
        },
        isModified: {
            type: Boolean
        },
        isEmpty: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        }
    },
    data() {
        return {
            widgetDrawOpen: false,
            showHints: false
        }
    },
    computed: {
        ...mapGetters({
            themeMode: 'user/themeMode'
        }),
        noWidgets() {
            return !this.widgets.any()
        },
        localUnlocked: {
            get() {
                return this.unlocked
            },
            set(v) {
                this.$emit('update:unlocked', v)
            }
        },
        guidanceColor() {
            if (this.themeMode == 'dark') {
                return '#3162ba'
            }
            return 'cyan'
        }
    },
    methods: {
        unlock() {
            this.localUnlocked = true
        },
        async clear() {
            var confirm = await this.confirm({
                title: 'Are You Sure?',
                acceptText: 'Remove All',
                text: 'This will remove all widgets from the current dashboard. Are you sure you want to continue?'
            })
            if (!confirm) {
                return
            }
            this.$emit('clear')
        },
        async rollback() {
            var confirm = await this.confirm({
                title: 'Are You Sure?',
                acceptText: 'Reset',
                text: 'This will reset all changes to the current dashboard. Are you sure you want to continue?'
            })
            if (!confirm) {
                return
            }
            this.$emit('reset')
        },
        commit() {
            this.$emit('save')
        }
    },
    mounted() {
        setTimeout(
            function () {
                this.showHints = true
            }.bind(this),
            1000
        )
    }
}
</script>

<style lang="scss" scoped>
.control-buttons {
    position: fixed;
    right: -5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 50000;
    ::v-deep .vs-icon {
        transform: scale(1.5);
    }

    ::v-deep .vs-button {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    & > * {
        transition: all 0.15s ease;
        margin-bottom: 0.5rem;
        &:not(.disabled):hover {
            transform: scale(1.05) translateX(-2px);
        }
    }
}
</style>
